import { useMutation, useQuery } from '@apollo/client';
import {
  Alert,
  Button,
  Checkbox,
  FormControl,
  FormControlLabel,
  FormLabel,
  Grid,
  Radio,
  RadioGroup,
  TextField,
} from '@mui/material';
import { ChangeEvent, MouseEventHandler, useRef, useState } from 'react';
import { GQL_RTSP_PUSH, GQL_RTSP_PUSH_STOP } from '../../graphql/mutations/cameras';
import { GQL_RTSP_PUSH_LIST } from '../../graphql/queries/cameras';

const interval: number = parseInt(process.env.REACT_APP_PUSH_REFRESH_INTERVAL || '30000');

export default function RTSPPush({ camera }: { camera: string }) {
  const [push] = useMutation(GQL_RTSP_PUSH, {
    refetchQueries: [{ query: GQL_RTSP_PUSH_LIST, variables: { cameraId: camera } }],
    awaitRefetchQueries: true,
  });
  const [stop] = useMutation(GQL_RTSP_PUSH_STOP, {
    refetchQueries: [{ query: GQL_RTSP_PUSH_LIST, variables: { cameraId: camera } }],
    awaitRefetchQueries: true,
  });
  const [pushCount, setPushCount] = useState<number>(0);
  const pushUrl = useRef<HTMLInputElement>(null);
  const mutedAudio = useRef<HTMLInputElement>(null);
  const [acodec, setAcodec] = useState('copy');
  const [waitingPush, setWaitingPush] = useState(false);
  const [pushes, setPushes] = useState<any[]>([]);

  const [stopCount, setStopCount] = useState(0);
  const { data } = useQuery(GQL_RTSP_PUSH_LIST, {
    variables: {
      cameraId: camera,
    },
    pollInterval: interval,
    notifyOnNetworkStatusChange: true, //TODO: it should not be necessary. Should render when chenaged
    onCompleted(data) {
      console.log('complete', data);
      const _pushes = data.pushs.map((push: any) => {
        return { ...push, stop: false };
      });
      setPushes(_pushes);
      setWaitingPush(false);
    },
  });
  console.log('count', pushCount, stopCount, pushes, data);

  const onStop = function (pushId: string): MouseEventHandler<HTMLButtonElement> {
    return function () {
      const push: any = pushes.find((push: any) => {
        return push.container == pushId;
      });
      if (push) push.stop = true;
      stop({ variables: { cameraId: camera, pushId } } as any).then((success) => {
        if (success) setPushes(pushes.filter((push: any) => push.container != pushId));
        setStopCount((c) => c + 1);
      });
    };
  };

  const onChangeCodec = function (e: ChangeEvent<HTMLInputElement>) {
    setAcodec(e.target.value);
  };

  const onPush = function () {
    const params: any = {
      variables: {
        rtspPushInput: {
          camera: camera,
          url: pushUrl.current?.value || '',
          mute: mutedAudio.current?.checked || false,
          acodec: acodec,
        },
      },
    };
    if (pushUrl.current) pushUrl.current.value = '';
    setWaitingPush(true);
    push(params)
      .then((data: any) => {
        console.log(data.data.push);
        setPushes((pushes) => {
          return [...pushes, data.data.push];
        });
        setWaitingPush(false);
        setPushCount((c) => c + 1);
      })
      .catch((e) => {
        console.log('error', e);
        setWaitingPush(false);
      });
  };
  return (
    <>
      {waitingPush && (
        <Grid item xs={12}>
          <Alert severity="warning">Wait previous push finish before summit another.</Alert>
        </Grid>
      )}
      <Grid item xs={12}>
        <TextField label="Enter RTSP url to push" fullWidth inputRef={pushUrl} />
      </Grid>

      <Grid item flexGrow={1}>
        <FormControl component="fieldset">
          <FormLabel component="legend">Audio Codec</FormLabel>
          <RadioGroup value={acodec} onChange={onChangeCodec} row>
            <FormControlLabel value="copy" control={<Radio />} label="copy" />
            <FormControlLabel value="aac" control={<Radio />} label="aac" />
            <FormControlLabel value="mp3" control={<Radio />} label="mp3" />
          </RadioGroup>
        </FormControl>
      </Grid>

      <Grid item>
        <Button color="secondary" variant="contained" onClick={onPush} disabled={waitingPush}>
          Push
        </Button>
      </Grid>
      <Grid item xs={12}>
        <FormControlLabel inputRef={mutedAudio} control={<Checkbox />} label="Add muted audiotrack" />
      </Grid>
      {pushes?.map((push: any, index: number) => {
        return (
          <Grid item container key={index}>
            <Grid item xs>
              {push.url}
            </Grid>
            <Grid item xs={1}>
              <Button onClick={onStop(push.container)} variant="contained" color="secondary" disabled={push.stop}>
                Stop
              </Button>
            </Grid>
          </Grid>
        );
      })}
    </>
  );
}
